import __request__ from "routing/request";
export function get(sourceId, sort = "title", page = 1, per_page = 15, query, filters, direction = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends`, null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(sourceId, JSONbody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getBackend(sourceId, importId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends/${importId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(sourceId, importId, JSONbody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends/${importId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(sourceId, importId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends/${importId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function scheduleImport(sourceId, importId, JSONbody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends/${importId}/schedule`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
